<template>
	<div class="beta-wrapper">
		<slot></slot>
		<!-- Place your content here -->
		<div class="beta-indicator">
			<img src="@/assets/icon/betaPin.svg" alt="Beta" />
		</div>
	</div>
</template>

<script setup></script>

<style scoped>
.beta-wrapper {
	position: relative;
	outline: 5px solid var(--bleu-200);
	border: 0px solid transparent;
	border-radius: 16px;
	padding: 1rem;
    margin-top: .85rem;
	/* background-color: var(--bleu-100); */
}

.beta-indicator {
	position: absolute;
	top: -15px;
	right: -17px;
}

.beta-indicator img {
	width: 80px;
	height: 80px;
}
</style>
